'use strict';

angular.module('clientDashboardApp').directive('starRating', ['$log', function ($log) {
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            starRating: '=',
            unimportantColor: '=',
            provider: '='
        },
        replace: true,
        template: '<div class="star-rating"></div>',
        link: function (scope, elem, attrs, ctrl) {
            if (typeof scope.starRating == "string") {
              scope.starRating = Number(scope.starRating)
            }
            if(!angular.isDefined(scope.starRating)){
                return;
            }
            if(scope.starRating < 0 || scope.starRating > 5){
                $log.warn('Invalid rating! Rating:' + scope.rating);
                return;
            }

            var ratingStyle = 'rating-';
            if (scope.unimportantColor && true) {
              ratingStyle += "unimportant"
            } else if (scope.starRating >= 4) {
                ratingStyle += 'good';
            } else if (scope.starRating > 2.5) {
                ratingStyle += 'average';
            } else if (scope.starRating >= 0) {
                ratingStyle += 'poor';
            }

            var starTemplate = function(starClass){
                return '<i class="'+starClass+'"></i>';
            };

            var starHTML = '';
            for(var i = 1; i <= 5; i++){
                if(scope.starRating >= i){
                    starHTML += starTemplate('fas fa-star '+ratingStyle);
                }else if((scope.starRating + 0.5) >= i){
                    starHTML += starTemplate('fas fa-star-half '+ratingStyle);
                }else{
                    starHTML += starTemplate('far fa-star rating-empty');
                }
            }
            if(scope.provider === "YELP") {
              var imageLocation = window.assetUrl + "/images/yelpStars/" + scope.starRating + ".png"
              starHTML = '<img src="'+imageLocation+'" width="80%"/>'
            }
            elem.prepend(starHTML);
        }
    }
}]);
